import styled from '@emotion/styled';

import { DayElementProps, IconElementProps, WrapperElementProps } from './types';

export const CalendarDayElement = styled.div<DayElementProps>`
  font-family: ${({ theme }) => theme.field.general.font_family};
  font-size: ${({ theme }) => theme.field.general.font_size};
  color: ${({ theme }) => theme.calendar.color.normal};
  cursor: pointer;

  &[data-multiple='true'] {
    background: ${({ theme }) => theme.calendar.background.active};
  }

  &[data-boundary='true'] {
    color: ${({ theme }) => theme.calendar.color.boundary};
  }

  &[data-between='true'] {
    background: ${({ theme }) => theme.calendar.background.between};
  }

  &[data-hover='true'] {
    background: ${({ theme }) => theme.calendar.background.between};
  }

  &[data-since='true'] {
    color: ${({ theme }) => theme.calendar.color.active};
    background: ${({ theme }) => theme.calendar.background.active};
  }

  &[data-since='true']:hover {
    color: ${({ theme }) => theme.calendar.color.active};
    background: ${({ theme }) => theme.calendar.background.active};
  }

  &[data-to='true'] {
    color: ${({ theme }) => theme.calendar.color.active};
    background: ${({ theme }) => theme.calendar.background.active};
  }

  &[data-to='true']:hover {
    color: ${({ theme }) => theme.calendar.color.active};
    background: ${({ theme }) => theme.calendar.background.active};
  }

  &:hover {
    color: ${({ theme }) => theme.calendar.color.hover};
    background: ${({ theme }) => theme.calendar.background.between};
  }

  &[data-disabled='true'] {
    pointer-events: none;
    color: ${({ theme }) => theme.calendar.color.disabled};
    background: ${({ theme }) => theme.calendar.background.disabled};
    opacity: 0.8;
  }

  &[data-disabled='true']:hover {
    pointer-events: none;
    color: ${({ theme }) => theme.calendar.color.disabled};
    background: ${({ theme }) => theme.calendar.background.disabled};
  }
`;

export const CalendarWrapperElement = styled.div<WrapperElementProps>`
  &[data-since='true'] {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  &[data-to='true'] {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  &[data-hover='true'] {
    background: ${({ theme }) => theme.calendar.background.between};
  }
  &[data-between='true'] {
    background: ${({ theme }) => theme.calendar.background.between};
  }
`;

export const CalendarIconElement = styled.div<IconElementProps>`
  background: ${({ theme }) => theme.field.background.normal};
  border: 1px solid transparent;
  color: ${({ theme }) => theme.field.color.normal};

  &:hover {
    background: ${({ theme }) => theme.field.background.hover};
    border: ${({ theme }) => theme.field.border.hover};
    color: ${({ theme }) => theme.field.color.normal};
  }

  &:active {
    background: ${({ theme }) => theme.field.background.active};
    border: ${({ theme }) => theme.field.border.active};
    color: ${({ theme }) => theme.field.color.normal};
  }
`;
